import React from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ContentTable from './ContentTable';
import AuditoriaModal from './AuditoriaModal';
import { getTimeStr } from './helpers'
import { getRowsAndTotal } from '../../state/order/actions';
import Status from './helpers/Status';
import { getListOrigens, getLabelOrigem } from '../../main/origem';
import consts from '../../main/consts';

const styles = (theme) => ({
  status: {
    minWidth: 150
  },
  capitalize: {
    textTransform: 'capitalize'
  }
})

const getHeaders = (classes) => [{
  title: 'Nº Pedido',
  align: 'left',
  dataField: 'codigoExterno',
}, {
  title: 'Data',
  align: 'left',
  dataField: 'dataInclusao',
  render: (data) => getTimeStr(data),
}, {
  title: 'Cliente',
  align: 'left',
  dataField: 'cliente',
  class: classes.capitalize,
  render: (data) => data && data.nome.toLowerCase(),
}, {
  title: 'Origem',
  align: 'left',
  dataField: 'origem',
  filterOptions: getListOrigens(),
  render: (data) => getLabelOrigem(data)
}, {
  title: 'Status',
  align: 'center',
  dataField: 'status',
  class: classes.status,
  render: (data) => <Status status={data} />,
}, {
  title: 'Logs',
  align: 'center',
  dataField: 'valorTotal',
  class: classes.totalCost,
  render: () => <Button
    variant="contained"
    onClick={(e) => e.preventDefault()}
    color="primary"
  >Listar Logs</Button>,
}]

const PAGE_NAME = 'all-orders';
const ROWS_PER_PAGE = consts.ROWS_PER_PAGE;
class ProntoSair extends React.Component {
  state = {
    dataInicial: null,
    dataFinal: null,
    order: null,
    orderBy: null,
    find: '',
    logModal: {
      open: false,
      codigoExterno: null,
      origem: null,
      loja: null,
    }
  }

  componentDidMount() {
    this.loadGridData(0, ROWS_PER_PAGE);
  }

  componentDidUpdate(prevProps) {
    const { loja, orders: { filters } } = this.props;

    if (loja !== prevProps.loja || filters !== prevProps.orders.filters) {
      this.loadGridData(0, ROWS_PER_PAGE);
    }
  }

  loadGridData = (page, limit, avoidSpinner = false) => {

    const { getRowsAndTotal, orders: { filters } } = this.props;
    const { order, orderBy, ...stateFilters } = this.state

    if (order && orderBy) {
      stateFilters[orderBy] = order;
    }
    limit = limit || ROWS_PER_PAGE;

    getRowsAndTotal({
      page,
      limit,
      filters: { ...filters, ...stateFilters},
      avoidSpinner,
      pageId: PAGE_NAME
    });
  }

  clickRow = (row, event) => {
    if (event.defaultPrevented) {
      this.setState({ logModal: {
        open: true,
        codigoExterno: row.codigoExterno,
        origem: row.origem,
        loja: row.loja,
      } });
    } else {
      this.props.history.push(`/all-orders/${row.numero}`, {
        data: { page: PAGE_NAME }
      });
    }
  };

  handleOrderChange = (ordering) => {
    this.setState({ order: ordering.order, orderBy: ordering.orderBy }, () =>
      this.loadGridData(0, null, true)
    );
  }

  handleFilterChange = (value) => {
    this.setState({ find: value }, () => {
          if(this.state.find.length >=4 || this.state.find.length == 0) {
            this.loadGridData(0, null, true);
          }
    });
  }

  handleDateChange = (e) => {
    const { _d: date } = e || {};
    if (!date || !isNaN(date)) {
      this.setState({ dataInicial: date, dataFinal: date }, () =>
        this.loadGridData(0, null, true)
      );
    }
  }

  render() {
    const { dataInicial, find } = this.state;

    return (
      <>
        <AuditoriaModal
          open={this.state.logModal.open}
          handleClose={() => this.setState({ logModal: { open: false } })}
          codigoExterno={this.state.logModal.codigoExterno}
          origem={this.state.logModal.origem}
          loja={this.state.logModal.loja}
        />
        <ContentTable
          loaded={this.props.orders.loaded}
          title="Auditoria"
          subtitle=""
          page={PAGE_NAME}
          headers={getHeaders(this.props.classes)}
          onClickRow={this.clickRow}
          rows={this.props.orders.grids[PAGE_NAME].rows}
          total={this.props.orders.grids[PAGE_NAME].total}
          selectedPage={this.props.orders.page}
          rowsPerPage={ROWS_PER_PAGE}
          showPaginator={true}
          onHandlePageChange={this.loadGridData}
          filter={{
            enable: true,
            dataInicial,
            find,
            handleOrderChange: this.handleOrderChange,
            handleFilterChange: this.handleFilterChange,
            handleDateChange: this.handleDateChange,
          }}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return { orders: state.orders, loja: state.auth.loja };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getRowsAndTotal }, dispatch);
export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ProntoSair);
